// Griglia P/B/G/S (PBGS-1): criteri tri-stato come guida, voto 1–5 scelto dal Maestro. Proposta interna, non validata.
export const PBGS = [["P", "Piedi"], ["B", "Braccio armato"], ["G", "Guardia"], ["S", "Spalle"]];
export const LEVELS = [
  [1, "Gravemente insufficiente", "errori tecnici gravi e diffusi che compromettono il gesto"],
  [2, "Insufficiente", "errori frequenti e controllo insufficiente"],
  [3, "Sufficiente", "esecuzione accettabile con imprecisioni evidenti"],
  [4, "Buono", "esecuzione corretta e controllata con imperfezioni occasionali"],
  [5, "Ottimo", "esecuzione corretta, stabile, coordinata e ripetibile"],
];
const NEXT = { nv: "ok", ok: "ko", ko: "nv" };
const STYLE = { ok: "bg-emerald-600 text-white border-emerald-600", ko: "bg-red-600 text-white border-red-600", nv: "bg-white text-zinc-400 border-zinc-300" };
const MARK = { ok: "✓", ko: "✗", nv: "" };
export const isPbgs = (test) => test?.technical_rubric === "PBGS-1";

export function CriteriaToggles({ value = {}, onChange, disabled, testid, examples = {}, size = "h-9 w-9" }) {
  return (
    <div className="flex items-center gap-1">
      {PBGS.map(([k, l]) => {
        const st = value[k] || "nv";
        return (
          <button type="button" key={k} disabled={disabled} data-testid={`${testid}-${k}`}
            title={`${k} · ${l}: ${st === "ok" ? "soddisfatto" : st === "ko" ? "non soddisfatto" : "non valutato"}${examples[k] ? `\n${examples[k]}` : ""}`}
            onClick={() => onChange({ ...value, [k]: NEXT[st] })}
            className={`${size} rounded text-xs font-semibold border ${STYLE[st]}`}>{k}{MARK[st]}</button>
        );
      })}
    </div>
  );
}

export function ScoreInput({ value, onChange, disabled, testid, navProps = {} }) {
  return (
    <input data-testid={testid} inputMode="numeric" maxLength={1} disabled={disabled} placeholder="voto" title="Voto tecnico 1–5 (assegnato dal Maestro)"
      className="w-12 h-9 border border-zinc-400 rounded text-center font-mono text-base disabled:bg-zinc-50" value={value ?? ""} {...navProps}
      onChange={(e) => { const v = e.target.value.replace(/[^1-5]/g, "").slice(0, 1); onChange(v === "" ? null : Number(v)); }} />
  );
}

export function RubricGuide({ test }) {
  return (
    <details className="text-xs border border-zinc-200 rounded-md bg-white" data-testid="pbgs-guide">
      <summary className="cursor-pointer px-3 py-2 font-medium">Guida valutazione P/B/G/S e scala 1–5 (proposta interna, non validata scientificamente)</summary>
      <div className="px-3 pb-3 grid md:grid-cols-2 gap-3">
        <ul className="space-y-1">{PBGS.map(([k, l]) => <li key={k}><b>{k} · {l}</b>: {test.technical_examples?.[k] || "—"}</li>)}</ul>
        <ul className="space-y-1">{LEVELS.map(([n, l, d]) => <li key={n}><b>{n} — {l}</b>: {d}.</li>)}
          <li className="text-zinc-500">Criteri: clic = ✓ soddisfatto → ✗ non soddisfatto → vuoto non valutato. Il voto non è calcolato dai criteri. Prova nulla: nessun voto.</li></ul>
      </div>
    </details>
  );
}
